export default {
  apiKey: "AIzaSyC_C4A97pkDpMcC8VGviCPJEPLc16UBwwc",
  authDomain: "vomhof-3e2b8.firebaseapp.com",
  databaseURL: "https://vomhof-3e2b8.firebaseio.com",
  projectId: "vomhof-3e2b8",
  storageBucket: "vomhof-3e2b8.appspot.com",
  messagingSenderId: "862308845038",
  appId: "1:862308845038:web:44d93d8a12fbd0dc527aff",
  measurementId: "G-HX4VMCQ7HX",
};
